export default {
  invoiceList: {
    data: [],
    links: {
      first: '',
      last: '',
      prev: '',
      next: '',
    },
    meta: {
      current_page: 1,
      from: 1,
      last_page: 1,
      path: '',
      per_page: 0,
      to: 1,
      total: 0,
    },
  },
  invoice: {
    id: '',
    invoice_number: '',
    url: '',
    message: '',
    status: '',
    platform: '',
    application_fee: 0,
    receipt_pdf: null,
    created_at: '',
    updated_at: '',
    payment_provider: {
      provider: '',
      public_key: '',
      currency: '',
    },
    order: {
      shipping: true,
      status: '',
      tracking_company: '',
      tracking_number: '',
      tracking_url: '',
      fulfilled_at: '',
    },
    contact: {
      id: '',
      phone: '',
      platform: '',
      first_name: '',
      last_name: '',
      address: {
        city: '',
        line: '',
        postal_code: '',
        state: '',
        country: '',
      },
    },
    purchase_summary: {
      shipping: true,
      shipping_cost: 0,
      total: 0,
      subtotal: 0,
      currency: '',
      tax: 0,
      items: [
        {
          name: '',
          description: '',
          amount: 0,
          currency: '',
          quantity: 0,
          tax: 0,
        },
      ],
    },
  },
  publicInvoice: {
    id: '',
    invoice_number: '',
    status: '',
    payment_provider: {
      provider: '',
      public_key: '',
      currency: '',
    },
    purchase_summary: {
      shipping: true,
      shipping_cost: 0,
      total: 0,
      subtotal: 0,
      currency: '',
      tax: 0,
      items: [
        {
          name: '',
          description: '',
          amount: 0,
          currency: '',
          quantity: 0,
          tax: 0,
        },
      ],
    },
  },
  nextInvoiceNumber: '',
  totalRevenue: 0,
  apiError: {},
  calculatedTax: false,
  loadingData: true,
  invoiceCreated: false,
  invoiceDeleted: false,
  checkoutSucceeded: false,
};
